import { Component, OnInit } from '@angular/core';
import { RegistrationService } from 'src/app/services/registration.service';
import { RegistrationVerify } from 'src/app/models/registration-verify.model';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-registration-verify-search',
  templateUrl: './registration-verify-search.component.html',
  styleUrls: ['./registration-verify-search.component.scss']
})
export class RegistrationVerifySearchComponent implements OnInit {
  declarationNumber: any;
  registrationVerify: any;
  notFound: any;
  messageNotFound: any;
  messageNotReply: any;
  currentUser: any;
  notReply: any;
  constructor(private registrationService: RegistrationService, private afAuth: AngularFireAuth) { }
  ngOnInit(): void { }

  search() {
    this.afAuth.authState.subscribe(user => {
      this.currentUser = user;
    });
    this.registrationVerify = null;
    this.registrationService.search(this.declarationNumber).subscribe(data => {
      this.registrationVerify = data[0];
      if (this.registrationVerify) {
        this.notFound = true;
        if (!this.registrationVerify.verifyName && !this.registrationVerify.feedbackInformation) {
          this.messageNotReply = "Tờ khai chưa được phân công kiểm hoá";
          this.notReply = true;
        }
      } else {
        this.notFound = false;
        this.messageNotFound = "Không tìm thấy số tờ khai " + this.declarationNumber;
      }
    });
  }
}
